import isPlainObject from 'lodash/isPlainObject';

import { ModuleDataInput } from '@spotify/confidence-graphql';

export const getWorkflowName = (id: string) => `workflows/${id}`;

export const mergeModuleData2 = (
  moduleData2: ModuleDataInput,
  newModuleData2: ModuleDataInput,
): ModuleDataInput => {
  const result = { ...moduleData2 } as Record<string, unknown>;

  for (const key of Object.keys(newModuleData2)) {
    const existingValue = result[key];
    const newValue = (newModuleData2 as Record<string, unknown>)[key];

    if (isPlainObject(existingValue) && isPlainObject(newValue)) {
      result[key] = {
        ...(existingValue as Record<string, unknown>),
        ...(newValue as Record<string, unknown>),
      };
    } else {
      result[key] = newValue;
    }
  }

  return result as ModuleDataInput;
};
